import React, { FunctionComponent, useEffect, useState } from 'react';
import withContext from '../../ContextAPI/Context_HOC';
import CircularProgress from '@material-ui/core/CircularProgress';
import { OCSURL } from '../../constants';
import FundProxy from '../../Fund/FundProxy';
import { FundDetailsResponse } from '@usbnc/data-api-proxies';
import { dateStringToDisplayDate } from '../../Utilities/UtilityFunctions';

const FundNumbersTable: FunctionComponent<{
  context: { fundProxy: FundProxy };
}> = ({ context: { fundProxy } }) => {
  const [fundDetails, setFundDetails] = useState<FundDetailsResponse>({});
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fundDetailsSubscription = fundProxy.getDetails().subscribe({
      next: (x) => {
        if (!x.fundGroups?.length) {
          setError('No numbers found.');
          setFundDetails({});
          setLoading(false);
          return;
        }
        setFundDetails(x);
        setError(null);
        setLoading(false);
      },
      error: () => {
        setError('Failed to load numbers. Please try again later.');
        setFundDetails({});
        setLoading(false);
      },
    });
    return () => {
      fundDetailsSubscription.unsubscribe();
    };
  }, [fundProxy]);

  function commaSeparateNumber(val?: number) {
    if (!val) return '';
    let roundedVal: number | string = Math.round(val);
    while (/(\d+)(\d{3})/.test(roundedVal.toString())) {
      roundedVal = roundedVal.toString().replace(/(\d+)(\d{3})/, '$1,$2');
    }
    return '$' + roundedVal;
  }

  if (error) {
    return (
      <div className="fund-video-loading-container">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="fund-video-loading-container">
        <CircularProgress data-cy="loading-animation-container" className="loading-animation" size={80} />
      </div>
    );
  }

  return (
    <div className="boxStyle">
      <h3>National Fund Update</h3>
      <p>
        <strong>
          For the year ending April 30, 2026. Contributions as of{' '}
          {fundDetails.statusDate ? dateStringToDisplayDate(fundDetails.statusDate) : ''}:
        </strong>
        <br />
        <br />
        {fundDetails.fundGroups ? (
          <>
            <strong>National Fund:</strong>
            <br />
            <strong className="red-text">
              {commaSeparateNumber(fundDetails.fundGroups.find((x) => x.name == 'National Bahá’í Fund Total')?.amount)}
            </strong>
            <br />
            <br />
            <strong>Regional Fund:</strong>
            <br />
            <strong className="red-text">
              {commaSeparateNumber(fundDetails.fundGroups.find((x) => x.name == 'RBCs/RTIs Fund')?.amount)}
            </strong>
            <br />
            <br />
            <strong>Continental Fund:</strong>
            <br />
            <strong className="red-text">
              {commaSeparateNumber(fundDetails.fundGroups.find((x) => x.name == 'Continental Fund Goal')?.amount)}
            </strong>
            <br />
            <br />
            <strong>International Fund:</strong>
            <br />
            <strong className="red-text">
              {commaSeparateNumber(fundDetails.fundGroups.find((x) => x.name == 'International Funds')?.amount)}
            </strong>
            <br />
            <br />
            <strong>Shrine of ‘Abdu’l-Bahá Fund</strong> (since inauguration of the Fund)
            <br />
            <strong className="red-text">
              {commaSeparateNumber(fundDetails.fundGroups.find((x) => x.name == 'Shrine of Abdu’l-Baha Fund')?.amount)}
            </strong>
          </>
        ) : (
          <></>
        )}
      </p>
      <a className="home-button small-bottom-margin full-width center" href={OCSURL} target="_blank" rel="noopener noreferrer">
        Online Contribution System
      </a>
      <a
        className="home-button small-bottom-margin full-width center"
        href="https://www.bahaitreasurer.us/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Office of the Treasurer
      </a>
    </div>
  );
};

export default withContext(FundNumbersTable);
